declare var $: any;
//system
import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//services
import { LogService } from 'src/app/services/common/log.service';

//components
import { ConfirmReservationComponent } from 'src/app/components/studio/confirm-reservation/confirm-reservation.component';

//interfaces
import { SessionDetails } from 'src/app/models/studio/session-details';
import { ClassMemberModel } from 'src/app/models/studio/class-booking';
import { Subject } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { EnvironmentService } from 'src/app/services/environment.service';

@Component({
  selector: 'app-spot-grid',
  templateUrl: './spot-grid.component.html',
  styleUrls: ['./spot-grid.component.scss']
})
export class SpotGridComponent implements OnInit, OnDestroy {
  
  private readonly _unsubscribe: Subject<any> = new Subject();
  @Input() public sessionDetails! : SessionDetails;
  @Input() public friendIds : number[] = [];
  @Input() public balance: string;
  @Input() public membershipPaused: boolean = false;

  @Output() passEntry: EventEmitter<ClassMemberModel> = new EventEmitter();
  isLoading:              boolean = false;
  allowMultiSpotBooking:  boolean  = false;
  cellSquareSide:         number   = 40;
  spotAreaInCellPerc:     number   = 0.71;  //71%
  instructorFirstName:    string   = "";
  rows:                   number[] = new Array();
  cols:                   number[] = new Array();
  spots:                  number[] = new Array();
  selected:               number[] = new Array();
  booked:                 number[] = new Array();
  submitted:              boolean  = false;
  classMember!:           ClassMemberModel;

  constructor(
      public activeModal: NgbActiveModal
    , private modalService: NgbModal
    , private logService: LogService
    , private alertService: AlertService
    , private _environmentService: EnvironmentService
  ) {
    
  }

  ngOnInit(): void {
    this.isLoading = true;
    
    this.allowMultiSpotBooking = this._environmentService.getFacilityConfig().allowMultiSpotBooking;
    this.spots = this.sessionDetails.SpotConfig.Spots.split(",").map((value) => parseInt(value));

    this.rows = this.getRange(this.sessionDetails.SpotConfig.SpotRows);
    this.cols = this.getRange(this.sessionDetails.SpotConfig.SpotColumns);

    for (const obj of this.sessionDetails.ClassMembers) {
      this.booked.push(obj.Spot);
    }

    this.instructorFirstName = this.sessionDetails.InstructorName.split(' ')[0];
    console.log("spot config", this.sessionDetails.SpotConfig);
  }

  ngOnDestroy(): void {
    this._unsubscribe.next(null);
    this._unsubscribe.complete();
  }

  getTableStyle() {
    return {
      'width.px': (this.sessionDetails.SpotConfig.SpotColumns * (this.cellSquareSide + this.cellSquareSide * 0.04)),
      'height.px': (this.sessionDetails.SpotConfig.SpotRows * (this.cellSquareSide + this.cellSquareSide * 0.04)),
    };
  }

  getInstructorLayerStyle() {
    let tableLeft = 0;
    let tableTop = 0;
    const table = document.querySelector('table.spot-grid') as HTMLElement;
    if (table) {
      tableLeft = table.offsetLeft;
      tableTop = table.offsetTop;
    }
    return {
      'left.px': tableLeft + (this.sessionDetails.SpotConfig.InstructorOffsetX * (this.cellSquareSide + this.cellSquareSide * 0.04)),
      'top.px': tableTop + (this.sessionDetails.SpotConfig.InstructorOffsetY * (this.cellSquareSide + this.cellSquareSide * 0.04)),
      'width.px': (this.sessionDetails.SpotConfig.InstructorWidth * this.cellSquareSide),
      'height.px': (this.sessionDetails.SpotConfig.InstructorHeight * this.cellSquareSide),
    };
  }

  selectToggle(spot: number) {
    if(this.booked.includes(spot))
      return;

    if(this.allowMultiSpotBooking)
    {
      if(this.selected.includes(spot))
      {
        const index = this.selected.indexOf(spot);
        if (index > -1) {
          this.selected.splice(index, 1);
        }
      } else {
        this.selected.push(spot);
      }
    } else {
      this.selected = [];
      this.selected.push(spot);
    }
  }

  isFriend(spot: number): boolean {
    const classMember = this.sessionDetails.ClassMembers.find(c => c.Spot === spot);
    var memberId: number = classMember ? classMember.MemberId : -1;
    return this.friendIds.includes(memberId);
  }

  getFriendAvatar(spot: number): string {
    const classMember = this.sessionDetails.ClassMembers.find(c => c.Spot === spot);
    return classMember ? classMember.MemberInHouseAvatar : "";
  }

  getRange(n: number): number[] {
    return Array.from({length: n}, (_, i) => i);
  }

  closeModal() {
    this.passEntry.emit(this.classMember);
    this.activeModal.close(this.classMember);
  }

  confirmSpot() {
    if (this.membershipPaused || this.balance === 'Paused') {
      return;
    }

    if(this.selected.length == 0)
    {
      // window.alert("Please select spot first.");
      this.alertService.error("Please select spot first.");
      return;
    }

    this.submitted = true;
    
    //open confirm reservation popup
    const modalRef =this.modalService.open(ConfirmReservationComponent, {
      ariaLabelledBy: 'modal-basic-title', 
      // size: 'lg',
      centered: true,
      fullscreen: window.innerWidth <= 768,
      // windowClass: 'custom-class'
    });

    //Passing sessionDetails to popup
    modalRef.componentInstance.sessionDetails = this.sessionDetails;
    modalRef.componentInstance.selectedSpots = this.selected;
    modalRef.componentInstance.membershipPaused = this.membershipPaused;

    //Retrieving ClassMember from popup
    modalRef.result.then((result: ClassMemberModel | undefined | null) => {
      if(typeof result == "undefined")
      {
        this.closeModal();
        return;
      }
      
      if (result === null) {
        this.submitted = false;
        return;
      }
      if (result) {
        this.logService.debug("class booking details:", result);
        this.classMember = result;
        this.closeModal();
      }
    });
  }

  goToPurchase() {
    window.open('/purchase', '_self');
    return;
  }
}
